import type { Vacancy, VacancyWithAtsJob } from 'clients/AutoCompleteClient/types';

import { campaignsClient } from 'clients/CampaignsClient/CampaignsClient';
import { logger } from 'config/logger';
import { queryClient } from 'config/queryClient';
import { useCampaignStore } from 'stores/campaign/campaign.store';
import { QueryKey } from 'types/query';
import { getVacancyName } from 'utils/vacancyEnrichedUtils';

export const syncCampaignConnectedAtsVacancy = async (enrichedVacancy: Vacancy) => {
  const campaign = useCampaignStore.getState().campaign;

  if (!campaign?.id || !campaign.connected_ats?.job_ats_id || !enrichedVacancy.job_ats_id) {
    return;
  }

  if (enrichedVacancy.job_ats_id !== campaign.connected_ats.job_ats_id) {
    return;
  }

  if (enrichedVacancy.type !== 'ATS' && enrichedVacancy.type !== 'ATS_RAW') {
    return;
  }

  const connectedAts: VacancyWithAtsJob = {
    ...enrichedVacancy,
    type: enrichedVacancy.type === 'ATS_RAW' ? 'ATS_RAW' : 'ATS',
    name: getVacancyName(enrichedVacancy),
    value: enrichedVacancy.job_ats_id,
  };

  useCampaignStore.getState().setCampaign({ ...campaign, connected_ats: connectedAts });

  try {
    const { data: updatedCampaign } = await campaignsClient.updateCampaign(campaign.id, {
      connected_ats: connectedAts,
    });

    useCampaignStore.getState().setCampaign(updatedCampaign);
    queryClient.setQueryData([QueryKey.campaignManagerContextUseCampaign, campaign.id], updatedCampaign);
  } catch (error) {
    logger.error(error);
  }
};
